import React from "react";
import PropTypes from "prop-types";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Container, Link, Typography } from "@mui/material";

import useStyles from "./useStyles";

const RichTextFooter = ({ richText }) => {
  const classes = useStyles();

  const options = {
    renderNode: {
      [BLOCKS.DOCUMENT]: (_node, children) => <div className={classes.root}>{children}</div>,
      [BLOCKS.HEADING_2]: (_node, children) => (
        <Typography variant="h2" className={classes.title}>
          {children}
        </Typography>
      ),
      [BLOCKS.HEADING_3]: (_node, children) => <Typography variant="h3">{children}</Typography>,
      [INLINES.HYPERLINK]: (_node, children) => (
        <Link href={_node.data.uri} target="_blank" rel="noreferrer">
          {children}
        </Link>
      ),
    },
  };

  const footer = documentToReactComponents(richText, options);

  return richText ? <Container>{footer}</Container> : null;
};

RichTextFooter.propTypes = {
  richText: PropTypes.shape(),
};

export default RichTextFooter;
